export interface Theme {
  name: string;
  primary: string;
  secondary: string;
  accent: string;
  background: string;
  text: string;
  border: string;
}
export const themes: Record<string, Theme> = {
  default: {
    name: 'Default (TNG)',
    primary: '#FF9966',
    secondary: '#CC99CC',
    accent: '#9999FF',
    background: '#000000',
    text: '#FFFFFF',
    border: '#FF9966',
  },
  zora: {
    name: 'Zora',
    primary: '#00CED1',
    secondary: '#20B2AA',
    accent: '#48D1CC',
    background: '#000000',
    text: '#FFFFFF',
    border: '#00CED1',
  },
  control: {
    name: 'Control',
    primary: '#4169E1',
    secondary: '#DC143C',
    accent: '#1E90FF',
    background: '#000000',
    text: '#FFFFFF',
    border: '#4169E1',
  },
  agimus: {
    name: 'Agimus',
    primary: '#FF00FF',
    secondary: '#9370DB',
    accent: '#FFD700',
    background: '#000000',
    text: '#FFFFFF',
    border: '#FF00FF',
  },
  daystrom_m5: {
    name: 'Daystrom M-5',
    primary: '#FFA500',
    secondary: '#D2B48C',
    accent: '#FF8C00',
    background: '#000000',
    text: '#FFFFFF',
    border: '#FFA500',
  },
  jarvis: {
    name: 'Jarvis',
    primary: '#87CEEB',
    secondary: '#4682B4',
    accent: '#00BFFF',
    background: '#000000',
    text: '#FFFFFF',
    border: '#87CEEB',
  },
  colossus: {
    name: 'Colossus',
    primary: '#FF4500',
    secondary: '#696969',
    accent: '#FF6347',
    background: '#000000',
    text: '#FFFFFF',
    border: '#FF4500',
  },
  daystrom_m4: {
    name: 'Daystrom M-4',
    primary: '#9370DB',
    secondary: '#FF8C00',
    accent: '#BA55D3',
    background: '#000000',
    text: '#FFFFFF',
    border: '#9370DB',
  },
  peanut_hamper: {
    name: 'Peanut Hamper',
    primary: '#32CD32',
    secondary: '#FF69B4',
    accent: '#00FA9A',
    background: '#000000',
    text: '#FFFFFF',
    border: '#32CD32',
  },
  landru: {
    name: 'Landru',
    primary: '#B85C38',
    secondary: '#8B4513',
    accent: '#DAA520',
    background: '#1A1A1A',
    text: '#FFFFFF',
    border: '#B85C38',
  },
  guardian: {
    name: 'Guardian',
    primary: '#708090',
    secondary: '#2F4F4F',
    accent: '#FFD700',
    background: '#0F0F0F',
    text: '#FFFFFF',
    border: '#708090',
  },
  aegis: {
    name: 'Aegis',
    primary: '#000080',
    secondary: '#191970',
    accent: '#20B2AA',
    background: '#0A0A0A',
    text: '#FFFFFF',
    border: '#000080',
  },
};
export const defaultTheme = 'default';
